import { Component } from '@angular/core';
import { BaseFormDirective } from 'src/app/directives/base-form.directive';

@Component({
  selector: 'app-gender-form',
  templateUrl: './gender-form.component.html',
  styleUrls: ['./gender-form.component.sass']
})
export class GenderFormComponent extends BaseFormDirective {
  override title = 'MENU.GENDERS'
  override form = {
    name_: null
  }
  path = 'gender'

  override getItemEdit() {
    this.editService = this.data.core.genderUnique(this.editId)
    super.getItemEdit()
  }

  override setSubmitMethods(): void {
    this.postService = this.data.core.genderCreate(this.formSanitized)
    this.putService = this.data.core.genderUpdate(this.editId, this.formSanitized)
  }
}
